{
  "menu": {
    "title": "Solicitudes",
    "badgeLabel": "{count} solicitudes pendientes"
  },
  "title": "Solicitudes de vinculación",
  "subtitle": "Quiénes pidieron usar Fermin desde otro teléfono. Aprobar revoca el dispositivo anterior.",
  "fields": {
    "worker": "Trabajador",
    "primarySite": "Sede principal",
    "device": "Dispositivo",
    "requestedAt": "Solicitada",
    "expiresAt": "Vence",
    "status": "Estado"
  },
  "status": {
    "PENDING": "Pendiente",
    "APPROVED": "Aprobada",
    "REJECTED": "Rechazada",
    "EXPIRED": "Vencida"
  },
  "platform": {
    "ios": "iPhone",
    "android": "Android",
    "desktop": "Escritorio",
    "other": "Otro"
  },
  "displayMode": {
    "standalone": "Aplicación instalada",
    "browser": "Navegador"
  },
  "filters": {
    "status": "Estado",
    "statusAll": "Todas"
  },
  "actions": {
    "approve": "Aprobar",
    "reject": "Rechazar"
  },
  "table": {
    "caption": "Solicitudes de vinculación de dispositivo",
    "actions": "Acciones",
    "device": "{platform} · {mode}",
    "expired": "Vencida"
  },
  "empty": {
    "title": "No hay solicitudes pendientes",
    "description": "Cuando alguien intente usar Fermin desde otro teléfono, su solicitud aparecerá aquí."
  },
  "confirm": {
    "approve": {
      "title": "Aprobar la vinculación",
      "description": "«{name}» podrá marcar desde el nuevo dispositivo.",
      "warning": "El dispositivo anterior quedará revocado y su sesión se cerrará. No se puede deshacer desde aquí.",
      "confirm": "Aprobar"
    },
    "reject": {
      "title": "Rechazar la solicitud",
      "description": "«{name}» seguirá marcando solo desde su dispositivo actual.",
      "reason": "Motivo",
      "reasonHelp": "Opcional. Queda en la auditoría, hasta 500 caracteres.",
      "confirm": "Rechazar"
    }
  },
  "toast": {
    "approved": "Dispositivo vinculado",
    "rejected": "Solicitud rechazada"
  },
  "warnings": {
    "PENDING_REBIND_REQUESTS": "Tienes {count} solicitudes de vinculación esperando respuesta."
  },
  "errors": {
    "REBIND_NOT_PENDING": "La solicitud ya no está pendiente"
  },
  "tab": {
    "title": "Dispositivos"
  }
}
